import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconPlusCircle: FC<BaseIconProps> = ({ className, ...props }) => {
    return (
        <svg
            className={className}
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.3334 7.99996C14.3334 11.4978 11.4978 14.3333 8.00002 14.3333C4.50222 14.3333 1.66669 11.4978 1.66669 7.99996C1.66669 4.50216 4.50222 1.66663 8.00002 1.66663C11.4978 1.66663 14.3334 4.50216 14.3334 7.99996Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M8 5.17188V10.8287" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.8284 8H5.17157" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
